import React, { useState } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import bgLogin from "../../assets/bgLogin.png";
import "./styles.css";
import { alterarSenha } from "../../services/api";
import storageLocal from "../../services/storageLocal";
import services from "../../services";
import { message } from "antd";
import ApiService from "../../services/apiLogin";

export default function AlterarSenha() {
  const history = useHistory();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const emailParam = queryParams.get("email") || "";
  const codigoParam = queryParams.get("codigo") || "";
  const isAtivacao = !!(emailParam && codigoParam);

  const [formData, setFormData] = useState({
    email: emailParam,
    codigo: codigoParam,
    novaSenha: "",
    confirmarSenha: "",
  });

  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [passwordStrength, setPasswordStrength] = useState({
    score: 0,
    criteria: {
      length: false,
      letters: false,
      numbers: false,
      uppercase: false,
      special: false,
    },
  });

  const validatePassword = (password) => {
    const criteria = {
      length: password.length >= 8,
      letters: /[a-zA-Z]/.test(password),
      numbers: /\d/.test(password),
      uppercase: /[A-Z]/.test(password),
      special: /[!@#$%^&*(),.?":{}|<>]/.test(password),
    };

    const score = Object.values(criteria).filter(Boolean).length;

    setPasswordStrength({
      score,
      criteria,
    });

    return score >= 4; // Mínimo 4 critérios atendidos
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.email) {
      newErrors.email = "E-mail é obrigatório";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "E-mail inválido";
    }

    if (!formData.codigo) {
      newErrors.codigo = "Código é obrigatório";
    }

    if (!formData.novaSenha) {
      newErrors.novaSenha = "Nova senha é obrigatória";
    } else if (!validatePassword(formData.novaSenha)) {
      newErrors.novaSenha = "Senha não atende aos critérios mínimos";
    }

    if (!formData.confirmarSenha) {
      newErrors.confirmarSenha = "Confirmação de senha é obrigatória";
    } else if (formData.novaSenha !== formData.confirmarSenha) {
      newErrors.confirmarSenha = "Senhas não coincidem";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validateForm()) {
      return;
    }

    setIsLoading(true);

    try {
      const response = await alterarSenha({
        email: formData.email,
        codigo: formData.codigo,
        password: formData.novaSenha,
        confirmPassword: formData.confirmarSenha,
      });

      if (response.fail) {
        alert("Erro ao alterar senha. Verifique os dados informados.");
        return;
      }

      fnLogin();
    } catch (error) {
      console.error("Erro ao alterar senha:", error);
      alert("Erro ao alterar senha. Tente novamente.");
    } finally {
      setIsLoading(false);
    }
  };

  async function fnLogin() {
    storageLocal.set("tokenLogin", { token: "" });
    try {
      let response = await ApiService.apiLogin("AutenticarUsuario/logar", {
        email: formData.email,
        senha: formData.novaSenha,
      });

      // Verificar se a resposta tem statusCode (erro da API)
      if (response.statusCode >= 400) {
        message.error(response.message || "Erro na autenticação");
        return;
      }

      // Verificar se a resposta tem data (sucesso)
      if (response) {
        storageLocal.set("tokenLogin", { token: response.data });
        sessionStorage.setItem("authSistema", response.data);
        services.storage.set("isAuthenticated", true);
        history.push(`/galeria-midia`);
      } else {
        message.error("Resposta inválida do servidor");
      }
    } catch (err) {
      // Verificar se o erro tem response da API
      if (err.response?.data?.message) {
        message.error(err.response.data.message);
      } else if (err.message) {
        message.error(err.message);
      } else {
        message.error("Erro ao realizar login. Tente novamente.");
      }
      console.error("Login error:", err);
    }
  }

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));

    // Validar senha em tempo real
    if (field === "novaSenha") {
      validatePassword(value);
    }

    // Limpar erro do campo quando o usuário começar a digitar
    if (errors[field]) {
      setErrors((prev) => ({ ...prev, [field]: "" }));
    }
  };

  const getPasswordStrengthColor = () => {
    if (passwordStrength.score <= 1) return "#ff4d4f";
    if (passwordStrength.score <= 2) return "#faad14";
    if (passwordStrength.score <= 3) return "#1890ff";
    return "#52c41a";
  };

  const getPasswordStrengthText = () => {
    if (passwordStrength.score <= 1) return "Muito fraca";
    if (passwordStrength.score <= 2) return "Fraca";
    if (passwordStrength.score <= 3) return "Média";
    return "Forte";
  };

  return (
    <div className="login-container">
      <div className="login-content cadastro">
        <h2>
          <b className="fontGellyBold">{isAtivacao ? "Ativar Conta" : "Alterar Senha"}</b>
        </h2>
        <hr
          style={{
            width: "40px",
            margin: "16px 0 0 0",
            border: "1.5px solid #979797",
          }}
        />
        <p style={{ fontSize: 15 }}>
          {isAtivacao
            ? "Defina sua senha para ativar sua conta no sistema."
            : "Digite seu e-mail, o código de verificação enviado e sua nova senha."}
        </p>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "12px",
          }}
        >
          <div className="form-group">
            <label htmlFor="email" style={{ fontWeight: "bold" }}>
              E-mail
            </label>
            <input
              type="email"
              id="email"
              name="email"
              placeholder="Informe o seu e-mail"
              autoComplete="email"
              value={formData.email}
              onChange={(e) => handleInputChange("email", e.target.value)}
              className={errors.email ? "error" : ""}
            />
            {errors.email && (
              <span className="error-message">{errors.email}</span>
            )}
          </div>

          <div className="form-group">
            <label htmlFor="codigo" style={{ fontWeight: "bold" }}>
              Código de Verificação
            </label>
            <input
              type="text"
              id="codigo"
              name="codigo"
              placeholder="Digite o código recebido"
              autoComplete="off"
              value={formData.codigo}
              onChange={(e) => handleInputChange("codigo", e.target.value)}
              className={errors.codigo ? "error" : ""}
            />
            {errors.codigo && (
              <span className="error-message">{errors.codigo}</span>
            )}
          </div>

          <div className="form-group">
            <label htmlFor="novaSenha" style={{ fontWeight: "bold" }}>
              Nova Senha
            </label>
            <div className="input-password">
              <input
                type="password"
                id="novaSenha"
                name="novaSenha"
                placeholder="Digite sua nova senha"
                autoComplete="new-password"
                value={formData.novaSenha}
                onChange={(e) => handleInputChange("novaSenha", e.target.value)}
                className={errors.novaSenha ? "error" : ""}
              />
              <span className="icon-eye">{/* Ícone de olho aqui */}</span>
            </div>
            {errors.novaSenha && (
              <span className="error-message">{errors.novaSenha}</span>
            )}
          </div>

          <div className="form-group">
            <label htmlFor="confirmarSenha" style={{ fontWeight: "bold" }}>
              Confirmar Nova Senha
            </label>
            <div className="input-password">
              <input
                type="password"
                id="confirmarSenha"
                name="confirmarSenha"
                placeholder="Confirme sua nova senha"
                autoComplete="new-password"
                value={formData.confirmarSenha}
                onChange={(e) =>
                  handleInputChange("confirmarSenha", e.target.value)
                }
                className={errors.confirmarSenha ? "error" : ""}
              />
              <span className="icon-eye">{/* Ícone de olho aqui */}</span>
            </div>
            {errors.confirmarSenha && (
              <span className="error-message">{errors.confirmarSenha}</span>
            )}
          </div>
        </div>

        {/* Validação de senha */}
        {formData.novaSenha && (
          <div className="password-validation mb-3">
            <div className="password-strength">
              <div className="strength-bar">
                <div
                  className="strength-fill"
                  style={{
                    width: `${(passwordStrength.score / 5) * 100}%`,
                    backgroundColor: getPasswordStrengthColor(),
                  }}
                ></div>
              </div>
              <span
                className="strength-text"
                style={{ color: getPasswordStrengthColor() }}
              >
                {getPasswordStrengthText()}
              </span>
            </div>

            <div className="password-criteria">
              <div
                className={`criteria-item ${
                  passwordStrength.criteria.length ? "met" : ""
                }`}
              >
                ✓ Mínimo 8 caracteres
              </div>
              <div
                className={`criteria-item ${
                  passwordStrength.criteria.letters ? "met" : ""
                }`}
              >
                ✓ Letras (a-z)
              </div>
              <div
                className={`criteria-item ${
                  passwordStrength.criteria.numbers ? "met" : ""
                }`}
              >
                ✓ Números (0-9)
              </div>
              <div
                className={`criteria-item ${
                  passwordStrength.criteria.uppercase ? "met" : ""
                }`}
              >
                ✓ Letra maiúscula (A-Z)
              </div>
              <div
                className={`criteria-item ${
                  passwordStrength.criteria.special ? "met" : ""
                }`}
              >
                ✓ Caractere especial (!@#$%^&*)
              </div>
            </div>
          </div>
        )}

        <button
          className="btn-login"
          onClick={handleSubmit}
          disabled={isLoading}
        >
          {isLoading ? "Alterando..." : isAtivacao ? "Ativar Conta" : "Alterar Senha"}
        </button>

        <div
          className="d-flex justify-content-center"
          style={{ marginTop: "12px" }}
        >
          <Link
            to="/login"
            style={{ color: "#979797", textDecoration: "none" }}
          >
            Voltar para o login
          </Link>
        </div>
      </div>
    </div>
  );
}
